var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-center py-4 page-text--lg font-weight-bold primary--text"
  }, [_vm.disabled ? [_c('span', [_vm._v(" 필수 입력 필드가 " + _vm._s(_vm.toDo) + " 개 남았습니다. (" + _vm._s(_vm.done) + "/" + _vm._s(_vm.total) + ") ")])] : [_c('span', [_vm._v(" 필수 필드를 모두 입력하셨습니다. (" + _vm._s(_vm.done) + "/" + _vm._s(_vm.total) + ") ")])]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }